const useLowerCase = (text) => {
  return text.trim().toLowerCase();
};

export default useLowerCase;
